const approvalNotificationComponent = () => import("@/views/approvalNotificationBulk/approvalNotification.vue");
const approvalNotificationDetailsComponent = () => import("@/views/approvalNotificationBulk/approvalNotificationDetails.vue");

export default {
  path: "approvalNotification",
  meta: { label: "Approval Notification" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: approvalNotificationComponent,
    },
    {
      path: "ApprovalNotificationDetails/:id",
      name: "ApprovalNotificationDetails",
      meta: {
        requiresAuth: true,
      },
      component: approvalNotificationDetailsComponent,
    },
  ],
};
